import firebase from "firebase/app";
import "firebase/auth";

const getAuthSignInProvider = (provider) => {
  switch (provider) {
    case AUTH_PROVIDERS.EMAIL:
      return providerAuthEmail;

     case AUTH_PROVIDERS.GOOGLE:
      return providerAuthGoogle;

    case AUTH_PROVIDERS.FACEBOOK:
      return providerAuthFacebook;
    default:
      throw new Error(`Provider unknown: ${provider}`);
  }
};

const providerAuthEmail = async (auth, data) => auth.signInWithEmailAndPassword(data.email, data.password);

const providerAuthGoogle = async (auth) => {
  const provider = new firebase.auth.GoogleAuthProvider();
  return auth
    .signInWithPopup(provider);
};

const providerAuthFacebook = async (auth) => {
  const provider = new firebase.auth.FacebookAuthProvider();
  return auth
    .signInWithPopup(provider);
};

const AUTH_PROVIDERS = {
  EMAIL: "email",
  GOOGLE: "google.com",
  FACEBOOK: "facebook.com",
  PASSWORD: "password",
};

export {
  AUTH_PROVIDERS,
  getAuthSignInProvider,
};
